const pending = new Set();
const listeners = new Set();
let visible = false;
function publish() {
    const next = [...pending].some(request => request.slow);
    if (next === visible) return;
    visible = next;
    listeners.forEach(listener => listener(visible));
}
export function beginRequest() {
    const request = { slow: false };
    pending.add(request);
    const timer = setTimeout(() => { request.slow = true; publish(); }, 900);
    return () => { clearTimeout(timer); pending.delete(request); publish(); };
}
export function watchRequests(listener) {
    listeners.add(listener);
    listener(visible);
    return () => listeners.delete(listener);
}
